var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class Footer extends Component {
    constructor() {
        super('Footer', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            let timeout = null;
            $(window).on('resize', () => {
                clearTimeout(timeout);
                timeout = window.setTimeout(() => {
                    this.computeHeight();
                }, 100);
            });
            for (let i = 0; i < 3; i++) {
                setTimeout(() => {
                    this.computeHeight();
                }, 100 + i * 500);
            }
            this.computeHeight();
            this.success();
        });
    }
    computeHeight() {
        $('body').css('--footer-height', `${$('.component-footer').height() + parseInt($('main').css('margin-bottom'))}px`);
    }
}
